import React, { memo, useState, useEffect, useRef } from "react";
import {
  capitalizeAll,
  filterFromdateName,
  filterTodateName,
  useOutsideAlerter,
} from "../../utils/helper";
import { isInvalidDateRange } from "../../utils/dateRangeFilter";
import INTERVIEW from "../../utils/api/interview";
import CANDIDATE from "../../utils/api/candidate";
import FilterDateInput, { FILTER_DATE_POPPER_CLASS } from "./FilterDateInput";
import filter from "../../assets/images/filter.svg";
import filterDateLogo from "../../assets/admin Images/filter-date-logo.svg";
import SearchSelect from "./SearchSelect";
import { interviewSearchDropdownOptions, STATUSES } from "../../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import {
  getActiveEmployers,
  getActiveIncbotEmployers,
  getAdminFilterOptions,
  mockCandidatesList,
} from "../../redux/action";
import moment from "moment";

const FilterBtn = memo(
  ({
    filterType,
    setIsFilterData: onFilterDataChange,
    setDataControl,
    setClearFilter,
    type,
    refresh,
    isFilterData,
    setRefresh,
    isCompleted,
    subusersList,
    tab,
    filterFor,
    nameText,
    pageName,
    setIsDateSelected,
    setFromDate,
    setToDate,
    statusCandidate,
    setStatusCandidate,
    fromDate,
    toDate,
    setCurrentPage,
  }) => {
    // [INC-1910] Any filter change starts the list again from page 1, as search, sort and tenant
    // already do. Staying on page 4 of a 3-row result showed "No Record Found" above
    // "Showing 31 to 3 of 3 entries".
    const setIsFilterData = (filters) => {
      if (typeof setCurrentPage === "function") setCurrentPage(1);
      onFilterDataChange(filters);
    };
    const dispatch = useDispatch();
    const fromDateRef = useRef();
    const toDateRef = useRef();
    const allEmployerList = useSelector(
      (state) => state.UserAuth.activeEmployerList,
    );
    const allIncbotEmployerList = useSelector(
      (state) => state.Interview.activeIncbotEmployerList,
    );
    // InCFeed / InCVid: Job Title, Panelist, Created By options from the backend
    const isIncFeedVid = type === "incFeed" || type === "incVid";
    const adminFilterOptions = useSelector(
      (state) => state.Interview.adminFilterOptions,
    );
    const [showFilter, setShowFilter] = useState(false);
    const [employerList, setEmployerList] = useState([]);
    const ref = useRef();
    useOutsideAlerter(
      ref,
      () => setShowFilter(false),
      `.${FILTER_DATE_POPPER_CLASS}`,
    );
    const label = {
      Shortlisted: "shortlisted",
      Scheduled: "scheduled",
      Rejected: "rejected",
      "No Show": "noshow",
      Pending: "pending",
      Cancelled: "canceled",
      "On Hold": "hold",
    };
    const order = {
      "Newest to Oldest": "_id desc",
      "Oldest to Newest": "_id asc",
    };
    if (nameText) {
      order[`${nameText} (A - Z)`] =
        filterType === "interview" ? "candidateName asc" : "title asc";
    } else {
      order["Candidate Name (A - Z)"] =
        filterType === "interview" ? "candidateName asc" : "title asc";
    }
    const labelOptions =
      filterFor !== "candidate"
        ? [
            { label: "Active", value: "Active" },
            { label: "Closed", value: "Closed" },
            { label: "Deleted", value: "deleted" },
          ]
        : isIncFeedVid
          ? [
              { label: "Pending", value: "pending" },
              { label: "Scheduled", value: "scheduled" },
              { label: "Cancelled", value: "cancelled" },
              { label: "No Show", value: "noshow" },
              { label: "Shortlisted", value: "shortlisted" },
              { label: "Rejected", value: "rejected" },
              { label: "On Hold", value: "hold" },
            ]
          : type === "incBot"
            ? [
                { label: "Recommended", value: "Recommended" },
                { label: "Not Recommended", value: "Not Recommended" },
                {
                  label: "Cautiously Recommended",
                  value: "Cautiously Recommended",
                },
                { label: "Invited", value: "Invited" },
                { label: "Reinvited", value: "Reinvited" },
                { label: "In Progress", value: "In Progress" },
                { label: "Unattended", value: "Unattended" },
                { label: "Canceled", value: "Canceled" },
                {
                  label: "Feedback Approval Pending",
                  value: "feeback_approval_pending",
                },
                {
                  label: "Auto Approved",
                  value: "auto_approved",
                },
                {
                  label: "Resume Rejected",
                  value: "Resume Rejected",
                },
                {
                  label: "Network Disconnected",
                  value: "Network Disconnected",
                },
              ]
            : [
                { label: STATUSES.CANCELED, value: STATUSES.CANCELED },
                { label: STATUSES.COMPLETED, value: STATUSES.COMPLETED },
                { label: STATUSES.FOLLOW_UP, value: STATUSES.FOLLOW_UP },
                { label: STATUSES.IN_PROGRESS, value: STATUSES.IN_PROGRESS },
                { label: STATUSES.PENDING, value: STATUSES.PENDING },
                { label: STATUSES.NO_RESPONSE, value: STATUSES.NO_RESPONSE },
                { label: STATUSES.SCHEDULED, value: STATUSES.SCHEDULED },
              ];
    const feedback = {
      "Excellent: 9 to 10": "excellent",
      "Very Good: 7 to 8": "very_good",
      "Good: 6": "good",
      "Average: 5": "average",
      "Poor: 4": "poor",
      "Very Poor: <= 3": "very_poor",
    };
    const CreditType = [
      { label: "Prepaid", value: "prepaid" },
      { label: "Pay Per Use", value: "pay_per_use" },
    ];
    const [range, setRange] = useState("0");
    const [filterStates, setFilterStates] = useState({
      sort: "",
      status: "",
      from: "",
      to: "",
      experience: "",
      feedback: "",
      createdBy: "",
      completedFrom: "",
      completedTo: "",
      expiryFrom: "",
      expiryTo: "",
      approvedFrom: "",
      approvedTo: "",
      approvedBy: "",
      statusCandidate: "",
      interviewStartedFrom: "",
      interviewStartedTo: "",
      suspiciousActivity: "",
      interviewType: "",
    });
    const [filterStatus, setFilterStatus] = useState([]);
    const [filterSuspiciousActivity, setFilterSuspiciousActivity] = useState(
      [],
    );
    const [filterInterviewType, setFilterInterviewType] = useState([]);
    const completedFromRef = useRef();
    const completedToRef = useRef();
    const [status, setStatus] = useState("");
    const handleCompletedFromChange = (e) => {
      const val = completedFromRef.current?.value || "";
      const updated = { ...filterStates, completedFrom: val, statusCandidate };
      setFilterStates(updated);
      setIsFilterData(updated);
      if (typeof setFromDate === "function") {
        setFromDate(val);
      }

      if (typeof setIsDateSelected === "function") {
        const toVal = completedToRef.current?.value;
        setIsDateSelected(!!val || !!toVal);
      }
    };

    const handleCompletedToChange = (e) => {
      const val = completedToRef.current?.value || "";
      const updated = { ...filterStates, completedTo: val, statusCandidate };
      setFilterStates(updated);
      setIsFilterData(updated);

      if (typeof setToDate === "function") {
        setToDate(val);
      }

      if (typeof setIsDateSelected === "function") {
        const fromVal = completedFromRef.current?.value;
        setIsDateSelected(!!val || !!fromVal);
      }
    };

    // Manage Interviews (IncBot / IncScreen) date filters use FilterDateInput, which reports only
    // a picked day: the list refetches right when a date is selected, not on month switches.
    const isManageInterviews = pageName === "InCBotManageInterviews";
    const handleManageInterviewsDateChange = (key, value) => {
      const updated = { ...filterStates, [key]: value };
      setFilterStates(updated);
      setIsFilterData(updated);
    };
    // Expiry To earlier than Expiry From stays visible so it can be corrected, but the saga drops
    // it, so it never filters the list.
    const isExpiryRangeInvalid = isInvalidDateRange(
      filterStates?.expiryFrom,
      filterStates?.expiryTo,
    );

    // [INC-1987] Approved By: names of everyone who approved feedback, plus the system's
    // "Auto-Approved" (the name the backend logs for auto-approvals). Per tenant, like the list.
    const selectedTenant = useSelector((state) => state.UserAuth.selectedTenant);
    const [approverNames, setApproverNames] = useState([]);
    useEffect(() => {
      if (!isManageInterviews || (type !== "incBot" && type !== "incScreen")) return;
      const config = selectedTenant
        ? { headers: { "x-tenant-id": selectedTenant } }
        : {};
      const request =
        type === "incBot"
          ? INTERVIEW.get("/admin/incbot/approvers", config)
          : CANDIDATE.get("incscreen/admin/approvers", config);
      request
        .then((res) => setApproverNames(res?.data?.result || []))
        .catch(() => setApproverNames([]));
    }, [isManageInterviews, type, selectedTenant]);
    const approvedByOptions = [
      { label: "Auto-Approved Feedback", value: "Auto-Approved" },
      ...approverNames.map((name) => ({ label: name, value: name })),
    ];
    const isApprovedRangeInvalid = isInvalidDateRange(
      filterStates?.approvedFrom,
      filterStates?.approvedTo,
    );

    const handleInterviewTypeChange = (values) => {
      const isSelected = values.every((value) =>
        filterInterviewType.includes(value),
      );
      const finalTypes = isSelected
        ? filterInterviewType.filter((type) => !values.includes(type))
        : [
            ...filterInterviewType,
            ...values.filter((value) => !filterInterviewType.includes(value)),
          ];
      setFilterInterviewType(finalTypes);
      const filterStatesData = {
        ...filterStates,
        interviewType: finalTypes.join(","),
      };
      setFilterStates(filterStatesData);
      setIsFilterData(filterStatesData);
    };

    const handleSuspiciousActivityChange = (value) => {
      const index = filterSuspiciousActivity.indexOf(value);
      let finalActivity;
      if (index === -1) {
        finalActivity = [...filterSuspiciousActivity, value];
        setFilterSuspiciousActivity([...filterSuspiciousActivity, value]);
      } else {
        const updated = [...filterSuspiciousActivity];
        updated.splice(index, 1);
        finalActivity = updated;
        setFilterSuspiciousActivity(updated);
      }
      const filterStatesData = {
        ...filterStates,
        suspiciousActivity: finalActivity.join(","),
      };
      setFilterStates(filterStatesData);
      setIsFilterData(filterStatesData);
    };
    useEffect(() => {
      if (type === "incBot") {
        dispatch(getActiveIncbotEmployers());
      } else {
        dispatch(getActiveEmployers());
      }
    }, [dispatch, type]);

    useEffect(() => {
      if (isIncFeedVid) {
        dispatch(
          getAdminFilterOptions({
            product: type.toLowerCase(),
            user: filterStates?.user || "",
          }),
        );
      }
      // filterStates.user may hold several comma-joined employer ids now
      // (multi-select); the backend accepts the same comma list it already
      // accepts for `status`.
    }, [dispatch, type, isIncFeedVid, filterStates?.user]);

    useEffect(() => {
      const tmpArray = [
        {
          label: "Select Employer",
          value: "",
        },
      ];
      if (type === "incBot") {
        allIncbotEmployerList &&
          allIncbotEmployerList.length > 0 &&
          allIncbotEmployerList.map((element) => {
            if (element?.employer !== "") {
              tmpArray.push({
                value: element?._id,
                label: capitalizeAll(element?.employer),
              });
            }
          });
      } else {
        allEmployerList &&
          allEmployerList.length > 0 &&
          allEmployerList.map((element) => {
            if (element?.employer !== "") {
              tmpArray.push({
                value: element?._id,
                label: capitalizeAll(element?.employer),
              });
            }
          });
      }

      setEmployerList(tmpArray);
    }, [type, allEmployerList, allIncbotEmployerList]);

    useEffect(() => {
      const element = document.getElementById("rs-bullet");
      if (element) {
        document.getElementById("rs-bullet").style.left = `${
          (range * 80) / 30
        }%`;
      }
    }, [range]);

    const handleShowFilter = () => {
      setShowFilter(!showFilter);
      setRefresh(false);
      setClearFilter(false);
    };

    const handleFilterChange = (e, inputType, inputName) => {
      let filterStatesData;
      if (inputName === "range") {
        setRange(e.target.value);
        setFilterStates({ ...filterStates, [inputType]: e.target.value });
        filterStatesData = { ...filterStates, [inputType]: e.target.value };
      }

      if (!e.target.checked && inputName !== "range") {
        const currentStates = {
          ...filterStates,
        };
        if (inputType === "status") {
          currentStates.status = "";
        }
        setFilterStates(currentStates);
        filterStatesData = { ...filterStates };
        if (inputType === "status") {
          filterStatesData.status = "";
        } else {
          setFilterStates({ ...filterStates, [inputType]: e.target.value });
          filterStatesData = { ...filterStates, [inputType]: e.target.value };
        }
      } else {
        setFilterStates({ ...filterStates, [inputType]: e.target.value });
        filterStatesData = { ...filterStates, [inputType]: e.target.value };
      }
      if (inputType === "createdBy") {
      }
      if (setDataControl) {
        setDataControl((prev) => ({
          ...prev,
          interview: { ...prev.interview, currentPage: 1 },
        }));
      }

      if (filterType === "interview") {
        filterStatesData.status = filterStatesData.status
          ? filterStatesData.status
          : "";
        setIsFilterData(filterStatesData);
      } else {
        setIsFilterData(filterStatesData);
      }
    };
    const handleSelectChange = (e, name) => {
      let filterStatesData;
      setFilterStates({ ...filterStates, [name]: e.value });
      filterStatesData = { ...filterStates, [name]: e.value };
      setIsFilterData(filterStatesData);
    };

    // Same comma-joined-string convention as handleFilterStatusChange, so the
    // existing saga/backend $in handling works unchanged for multi-select.
    const handleMultiSelectChange = (selected, name) => {
      const joined = (selected || [])
        .map((o) => o.value)
        .filter(Boolean)
        .join(",");
      const filterStatesData = { ...filterStates, [name]: joined };
      setFilterStates(filterStatesData);
      setIsFilterData(filterStatesData);
    };

    const handleFilterStatusChange = (value) => {
      let filterStatesData;
      const index = filterStatus.indexOf(value);
      let finalStatus;
      if (index === -1) {
        finalStatus = [...filterStatus, value];
        setFilterStatus([...filterStatus, value]);
      } else {
        const newStatus = [...filterStatus];
        newStatus.splice(index, 1);
        finalStatus = newStatus;
        setFilterStatus(newStatus);
      }
      setFilterStates({ ...filterStates, status: finalStatus.join(",") });
      filterStatesData = { ...filterStates, status: finalStatus.join(",") };
      setIsFilterData(filterStatesData);
    };

    const handleSortChange = (e) => {
      const value = e?.target?.value || "";
      const updatedStates = { ...filterStates, sort: value };
      setFilterStates(updatedStates);
      setIsFilterData(updatedStates);
    };

    const isAnyFieldNotEmpty = () => {
      for (const key in filterStates) {
        if (filterStates[key] && filterStates[key].trim() !== "") {
          return true;
        }
        if (statusCandidate && statusCandidate.trim() !== "") {
          return true;
        }
      }
      return false;
    };

    const handleClearFilter = () => {
      let filterStatesData = {
        sort: "",
        status: "",
        from: "",
        to: "",
        experience: "",
        feedback: "",
        createdBy: "",
        completedFrom: "",
        completedTo: "",
        expiryFrom: "",
        expiryTo: "",
        approvedFrom: "",
        approvedTo: "",
        approvedBy: "",
        statusCandidate: "",
        interviewStartedFrom: "",
        interviewStartedTo: "",
        suspiciousActivity: "",
        interviewType: "",
      };
      if (isAnyFieldNotEmpty()) {
        setShowFilter(false);
        setClearFilter(true);
        setFilterStatus([]);
        setFilterSuspiciousActivity([]);
        setFilterInterviewType([]);
        setFilterStates(filterStatesData);
        setRange("0");
        setIsFilterData(filterStatesData);
        setStatus(true);

        if (typeof setFromDate === "function") setFromDate("");
        if (typeof setToDate === "function") setToDate("");
        if (typeof setIsDateSelected === "function") setIsDateSelected(false);
        if (typeof setStatusCandidate === "function") setStatusCandidate("");
      }
    };

    useEffect(() => {
      if (refresh === true) {
        handleClearFilter();
      }
      handleClearFilter();
    }, [refresh, tab]);

    useEffect(() => {
      if (filterType === "interview") {
        setFilterStates({
          sort: "",
          status: "",
          from: "",
          to: "",
          experience: "",
          feedback: "",
          createdBy: "",
          completedFrom: "",
          completedTo: "",
          expiryFrom: "",
          expiryTo: "",
          approvedFrom: "",
          approvedTo: "",
          approvedBy: "",
          statusCandidate: "",
          interviewStartedFrom: "",
          interviewStartedTo: "",
          suspiciousActivity: "",
          interviewType: "",
        });
      }
      if (type === "incExit") {
        setFilterStates({
          sort: "",
          from: "",
          to: "",
          // experience: "",
        });
      }
      if (type === "incServe") {
        setFilterStates({
          sort: "",
          from: "",
          to: "",
          experience: "",
          user: "",
          updatedFrom: "",
          updatedTo: "",
          acceptedFrom: "",
          acceptedTo: "",
          allotedForm: "",
          allotedTo: "",
          rescheduledFrom: "",
          rescheduledTo: "",
          scheduledFrom: "",
          scheduledTo: "",
          submittedFrom: "",
          submittedTo: "",
          canceledFrom: "",
          canceledTo: "",
        });
      }
      if (type === "incBot") {
        setFilterStates({
          sort: "",
          from: "",
          to: "",
          user: "",
          status: "",
          completedFrom: "",
          completedTo: "",
          expiryFrom: "",
          expiryTo: "",
          approvedFrom: "",
          approvedTo: "",
          approvedBy: "",
          interviewStartedFrom: "",
          interviewStartedTo: "",
          suspiciousActivity: "",
          interviewType: "",
        });
      }
      if (type === "incScreen") {
        setFilterStates({
          sort: "",
          from: "",
          to: "",
          user: "",
          status: "",
          completedFrom: "",
          completedTo: "",
          interviewType: "",
        });
      }
      if (isIncFeedVid) {
        setFilterStates({
          sort: "",
          from: "",
          to: "",
          user: "",
          status: "",
          position: "",
          panelist: "",
          createdBy: "",
        });
      }
    }, [filterType, type]);
    useEffect(() => {
      const { completedFrom, completedTo, sort } = filterStates;
      const selectedStatus = statusCandidate || filterStates.statusCandidate;

      // Only trigger API if any of the filters are set
      if (completedFrom || completedTo || selectedStatus || sort) {
        dispatch(
          mockCandidatesList({
            page: 1,
            pageSize: 10,
            from: completedFrom,
            to: completedTo,
            statusCandidate: selectedStatus,
            sort,
          }),
        );
      }
    }, [
      filterStates.completedFrom,
      filterStates.completedTo,
      filterStates.statusCandidate,
      filterStates.sort,
      statusCandidate,
    ]);

    const minDate = filterStates.from || "";
    const maxDate = new Date().toISOString().split("T")[0];

    return (
      <div className={`filter-btn-container position-relative ms-2`} ref={ref}>
        <button className="filter-btn d-center" onClick={handleShowFilter}>
          <img src={filter} alt="filter-btn" className="filter-img img-fluid" />
        </button>
        {showFilter && (
          <div
            className={`position-absolute filter-btn-popup input-shadow rounded f-reg ${type}`}
          >
            {pageName !== "MockInterviewCandidates" && (
              <div className="date-container f-reg">
                <label htmlFor="" className={"f-l"}>
                  <span className="f-sem-bol no-wrap">
                    {/* INC-1979: IncScreen shares IncBot's pageName but filters on the created date */}
                    {type === "incScreen"
                      ? "Created From"
                      : pageName === "InCBotManageInterviews"
                        ? "Invited From"
                        : type === "incVid" || type === "incFeed"
                          ? "Created From"
                          : "From"}
                  </span>
                  {isManageInterviews ? (
                    <FilterDateInput
                      value={
                        filterStates?.[filterFromdateName(pageName, tab)] ?? ""
                      }
                      maxDate={
                        filterStates?.[filterTodateName(pageName, tab)] ?? ""
                      }
                      onChange={(value) =>
                        handleFilterChange(
                          { target: { value } },
                          filterFromdateName(pageName, tab),
                        )
                      }
                    />
                  ) : (
                    <div
                      className="filter-date-container input-shadow"
                      onClick={() => {
                        if (fromDateRef.current) {
                          fromDateRef.current.showPicker();
                        }
                      }}
                    >
                      <input
                        ref={fromDateRef}
                        type="date"
                        max={
                          filterStates?.[filterTodateName(pageName, tab)] ?? ""
                        }
                        value={
                          filterStates?.[filterFromdateName(pageName, tab)] ??
                          ""
                        }
                        className="filter-input"
                        onChange={(e) =>
                          handleFilterChange(
                            e,
                            filterFromdateName(pageName, tab),
                          )
                        }
                      />
                      <div className="filter-date-placeholder f-med">
                        {filterStates?.[filterFromdateName(pageName, tab)]
                          ? moment(
                              filterStates?.[filterFromdateName(pageName, tab)],
                            ).format("DD-MM-YYYY")
                          : "Select a date"}
                      </div>
                      <img
                        src={filterDateLogo}
                        alt="filter date logo"
                        className="filter-date-logo"
                      />
                    </div>
                  )}
                </label>
                <label htmlFor="" className={"f-l"}>
                  <span className="f-sem-bol no-wrap">
                    {type === "incScreen"
                      ? "Created To"
                      : pageName === "InCBotManageInterviews"
                        ? "Invited To"
                        : type === "incVid" || type === "incFeed"
                          ? "Created To"
                          : "To"}
                  </span>
                  {isManageInterviews ? (
                    <FilterDateInput
                      value={
                        filterStates?.[filterTodateName(pageName, tab)] ?? ""
                      }
                      minDate={
                        filterStates?.[filterFromdateName(pageName, tab)] ?? ""
                      }
                      onChange={(value) =>
                        handleFilterChange(
                          { target: { value } },
                          filterTodateName(pageName, tab),
                        )
                      }
                    />
                  ) : (
                    <div
                      className="filter-date-container input-shadow"
                      onClick={() => {
                        if (toDateRef.current) {
                          toDateRef.current.showPicker();
                        }
                      }}
                    >
                      <input
                        ref={toDateRef}
                        type="date"
                        min={
                          filterStates?.[filterFromdateName(pageName, tab)] ??
                          ""
                        }
                        value={
                          filterStates?.[filterTodateName(pageName, tab)] ?? ""
                        }
                        className="filter-input"
                        onChange={(e) =>
                          handleFilterChange(e, filterTodateName(pageName, tab))
                        }
                      />
                      <div className="filter-date-placeholder f-med">
                        {filterStates?.[filterTodateName(pageName, tab)]
                          ? moment(
                              filterStates?.[filterTodateName(pageName, tab)],
                            ).format("DD-MM-YYYY")
                          : "Select a date"}
                      </div>
                      <img
                        src={filterDateLogo}
                        alt="filter date logo"
                        className="filter-date-logo"
                      />
                    </div>
                  )}
                </label>
              </div>
            )}
            {isIncFeedVid && (
              <div
                className="date-container f-reg"
                style={{ marginTop: "16px" }}
              >
                <label htmlFor="" className={"f-l"}>
                  <span className="f-sem-bol no-wrap">Scheduled From</span>
                  <div
                    className="filter-date-container input-shadow"
                    onClick={() => {
                      if (completedFromRef.current) {
                        completedFromRef.current.showPicker();
                      }
                    }}
                  >
                    {/* Read from filterStates, not the input: the panel unmounts on close, so the
                        input alone came back empty while the list stayed filtered (INC-1775) */}
                    <input
                      ref={completedFromRef}
                      type="date"
                      max={filterStates?.completedTo || ""}
                      value={filterStates?.completedFrom || ""}
                      className="filter-input"
                      onChange={handleCompletedFromChange}
                    />
                    <div className="filter-date-placeholder f-med">
                      {filterStates?.completedFrom
                        ? moment(filterStates.completedFrom).format(
                            "DD-MM-YYYY",
                          )
                        : "Select a date"}
                    </div>
                    <img
                      src={filterDateLogo}
                      alt="filter date logo"
                      className="filter-date-logo"
                    />
                  </div>
                </label>
                <label htmlFor="" className={"f-l"}>
                  <span className="f-sem-bol no-wrap">Scheduled To</span>
                  <div
                    className="filter-date-container input-shadow"
                    onClick={() => {
                      if (completedToRef.current) {
                        completedToRef.current.showPicker();
                      }
                    }}
                  >
                    <input
                      ref={completedToRef}
                      type="date"
                      min={filterStates?.completedFrom || ""}
                      value={filterStates?.completedTo || ""}
                      className="filter-input"
                      onChange={handleCompletedToChange}
                    />
                    <div className="filter-date-placeholder f-med">
                      {filterStates?.completedTo
                        ? moment(filterStates.completedTo).format("DD-MM-YYYY")
                        : "Select a date"}
                    </div>
                    <img
                      src={filterDateLogo}
                      alt="filter date logo"
                      className="filter-date-logo"
                    />
                  </div>
                </label>
              </div>
            )}
            {pageName === "InCBotManageInterviews" &&
              pageName !== "MockInterviewCandidates" && (
                <div
                  className="date-container f-reg"
                  style={{ marginTop: "16px" }}
                >
                  <label htmlFor="" className={"f-l"}>
                    <span className="f-sem-bol no-wrap">Completed From</span>
                    <FilterDateInput
                      value={filterStates?.completedFrom || ""}
                      maxDate={filterStates?.completedTo || ""}
                      onChange={(value) =>
                        handleManageInterviewsDateChange("completedFrom", value)
                      }
                    />
                  </label>
                  <label htmlFor="" className={"f-l"}>
                    <span className="f-sem-bol no-wrap">Completed To</span>
                    <FilterDateInput
                      value={filterStates?.completedTo || ""}
                      minDate={filterStates?.completedFrom || ""}
                      onChange={(value) =>
                        handleManageInterviewsDateChange("completedTo", value)
                      }
                    />
                  </label>
                </div>
              )}
            {/* IncBot only: IncScreen reuses this pageName but its interviews have no expiry date */}
            {pageName === "InCBotManageInterviews" && type === "incBot" && (
              <>
                <div
                  className="date-container f-reg"
                  style={{ marginTop: "16px" }}
                >
                  <label htmlFor="" className={"f-l"}>
                    <span className="f-sem-bol no-wrap">Expiry From</span>
                    <FilterDateInput
                      value={filterStates?.expiryFrom || ""}
                      maxDate={filterStates?.expiryTo || ""}
                      onChange={(value) =>
                        handleManageInterviewsDateChange("expiryFrom", value)
                      }
                    />
                  </label>
                  <label htmlFor="" className={"f-l"}>
                    <span className="f-sem-bol no-wrap">Expiry To</span>
                    <FilterDateInput
                      value={filterStates?.expiryTo || ""}
                      minDate={filterStates?.expiryFrom || ""}
                      onChange={(value) =>
                        handleManageInterviewsDateChange("expiryTo", value)
                      }
                    />
                  </label>
                </div>
                {isExpiryRangeInvalid && (
                  <div className="text-danger f-12 mt-1">
                    Expiry To date cannot be earlier than Expiry From date.
                  </div>
                )}
              </>
            )}
            {/* [INC-1987] Approved From / To / By: IncBot and IncScreen, filtered on the approval time */}
            {pageName === "InCBotManageInterviews" &&
              (type === "incBot" || type === "incScreen") && (
                <>
                  <div
                    className="date-container f-reg"
                    style={{ marginTop: "16px" }}
                  >
                    <label htmlFor="" className={"f-l"}>
                      <span className="f-sem-bol no-wrap">Approved From</span>
                      <FilterDateInput
                        value={filterStates?.approvedFrom || ""}
                        maxDate={filterStates?.approvedTo || ""}
                        onChange={(value) =>
                          handleManageInterviewsDateChange("approvedFrom", value)
                        }
                      />
                    </label>
                    <label htmlFor="" className={"f-l"}>
                      <span className="f-sem-bol no-wrap">Approved To</span>
                      <FilterDateInput
                        value={filterStates?.approvedTo || ""}
                        minDate={filterStates?.approvedFrom || ""}
                        onChange={(value) =>
                          handleManageInterviewsDateChange("approvedTo", value)
                        }
                      />
                    </label>
                  </div>
                  {isApprovedRangeInvalid && (
                    <div className="text-danger f-12 mt-1">
                      Approved To date cannot be earlier than Approved From date.
                    </div>
                  )}
                  <SearchSelect
                    name="approvedBy"
                    isMulti
                    hideSelectedOptions={false}
                    value={approvedByOptions.filter((itm) =>
                      (filterStates?.approvedBy || "")
                        .split(",")
                        .includes(itm.value),
                    )}
                    label="Approved By"
                    onChange={(e) => handleMultiSelectChange(e, "approvedBy")}
                    options={approvedByOptions}
                    labelClass="mb-1 mt-2 f-med title f-l"
                    inputClass="f-12 f-sem-bol input-shadow rounded"
                    borderNone
                    placeholder="Select Approved By"
                  />
                </>
              )}
            {pageName === "InCBotManageInterviews" &&
              pageName !== "MockInterviewCandidates" &&
              filterStatus.some((s) =>
                [
                  "Recommended",
                  "Not Recommended",
                  "Cautiously Recommended",
                  "In Progress",
                  "Network Disconnected",
                  "Reinvited",
                ].includes(s),
              ) && (
                <div
                  className="date-container f-reg"
                  style={{ marginTop: "16px" }}
                >
                  <label htmlFor="" className={"f-l"}>
                    <span className="f-sem-bol no-wrap">
                      Interview Started From
                    </span>
                    <FilterDateInput
                      value={filterStates?.interviewStartedFrom || ""}
                      maxDate={filterStates?.interviewStartedTo || ""}
                      onChange={(value) =>
                        handleManageInterviewsDateChange(
                          "interviewStartedFrom",
                          value,
                        )
                      }
                    />
                  </label>
                  <label htmlFor="" className={"f-l"}>
                    <span className="f-sem-bol no-wrap">
                      Interview Started To
                    </span>
                    <FilterDateInput
                      value={filterStates?.interviewStartedTo || ""}
                      minDate={filterStates?.interviewStartedFrom || ""}
                      onChange={(value) =>
                        handleManageInterviewsDateChange(
                          "interviewStartedTo",
                          value,
                        )
                      }
                    />
                  </label>
                </div>
              )}
            {pageName === "InCBotManageInterviews" &&
              pageName !== "MockInterviewCandidates" &&
              filterStatus.some((s) =>
                [
                  "Recommended",
                  "Not Recommended",
                  "Cautiously Recommended",
                  "In Progress",
                  "Network Disconnected",
                  "Reinvited",
                ].includes(s),
              ) && (
                <div style={{ marginTop: "16px" }}>
                  <div className="f-med title f-l">Suspicious Activity</div>
                  {["High", "Medium", "Low"].map((level) => (
                    <label
                      key={level}
                      htmlFor={`suspicious-${level}`}
                      className="f-l d-flex align-items-center"
                    >
                      <input
                        id={`suspicious-${level}`}
                        type="checkbox"
                        value={level}
                        checked={filterSuspiciousActivity.includes(level)}
                        onChange={() => handleSuspiciousActivityChange(level)}
                      />
                      <span>{level}</span>
                    </label>
                  ))}
                </div>
              )}
            {type !== "incExit" &&
              type !== "incServe" &&
              type !== "incBot" &&
              type !== "incScreen" &&
              !isIncFeedVid &&
              pageName !== "MockInterviewCandidates" && (
                <>
                  <div className="f-med title f-l">Labels</div>
                  {Object.entries(label).map((data, index) => (
                    <label
                      htmlFor={data[1]}
                      key={index}
                      className={"f-l d-flex align-items-center"}
                    >
                      <input
                        type="checkbox"
                        value={data[1]}
                        checked={filterStates?.status === data[1]}
                        onChange={(e) => handleFilterChange(e, "status")}
                      />
                      <span>{data[0]}</span>
                    </label>
                  ))}
                </>
              )}
            {isFilterData?.status !== "bulk" &&
              type !== "incExit" &&
              type !== "incBot" &&
              type !== "incScreen" &&
              !isIncFeedVid &&
              pageName !== "MockInterviewCandidates" && (
                <div className="range-box">
                  <div className="f-med title f-l">Experience</div>
                  <div className="range-slider f-l">
                    <div
                      // id="rs-bullet"
                      className="rs-label f-sem-bol d-center"
                      style={{ left: `${(range / 40) * 90}%` }}
                    >
                      {range}
                    </div>
                    <input
                      // id="rs-range-line"
                      className="rs-range"
                      type="range"
                      min={0}
                      max={40}
                      value={range}
                      onChange={(e) =>
                        handleFilterChange(e, "experience", "range")
                      }
                    />
                  </div>
                  <div className="box-minmax f-ph f-sem-bol">
                    <span>0yr</span>
                    <span>40yrs</span>
                  </div>
                </div>
              )}
            {type !== "incExit" && pageName !== "MockInterviewCandidates" && (
              <>
                <SearchSelect
                  name="user"
                  isMulti={isIncFeedVid}
                  hideSelectedOptions={false}
                  value={
                    isIncFeedVid
                      ? (employerList || []).filter(
                          (itm) =>
                            itm?.value &&
                            (filterStates?.user || "")
                              .split(",")
                              .includes(itm.value),
                        )
                      : // Raw id, not the option: SearchSelect finds the option by value,
                        // and an object never matches, which leaves react-select
                        // uncontrolled and drops the pick when the popup reopens.
                        filterStates?.user
                  }
                  label="Employer"
                  onChange={(e) =>
                    isIncFeedVid
                      ? handleMultiSelectChange(e, "user")
                      : handleSelectChange(e, "user")
                  }
                  options={employerList}
                  labelClass="mb-1 mt-2 f-med title f-l"
                  inputClass="f-12 f-sem-bol input-shadow rounded"
                  borderNone
                  placeholder={"Select a Employer"}
                />
              </>
            )}
            {isIncFeedVid &&
              [
                { name: "position", label: "Job Title", key: "positions" },
                { name: "panelist", label: "Panelist", key: "panelists" },
                { name: "createdBy", label: "Created By", key: "createdBy" },
              ].map(({ name, label, key }) => {
                const options = [
                  { label: `Select ${label}`, value: "" },
                  ...(adminFilterOptions?.[key] || []),
                ];
                return (
                  <SearchSelect
                    key={name}
                    name={name}
                    isMulti
                    hideSelectedOptions={false}
                    value={options.filter(
                      (itm) =>
                        itm?.value &&
                        (filterStates?.[name] || "")
                          .split(",")
                          .includes(itm.value),
                    )}
                    label={label}
                    onChange={(e) => handleMultiSelectChange(e, name)}
                    options={options}
                    labelClass="mb-1 mt-2 f-med title f-l"
                    inputClass="f-12 f-sem-bol input-shadow rounded"
                    borderNone
                    placeholder={`Select ${label}`}
                  />
                );
              })}
            {(type === "incBot" || type === "incScreen" || isIncFeedVid) &&
              pageName !== "MockInterviewCandidates" && (
                <>
                  <div className="f-med title f-l">Status</div>
                  {labelOptions.map((option, index) => (
                    <label
                      htmlFor={option.value}
                      key={index}
                      className="f-l d-flex align-items-center"
                    >
                      <input
                        type="checkbox"
                        value={option.value}
                        checked={filterStatus.includes(option.value)}
                        onChange={() => handleFilterStatusChange(option.value)}
                      />
                      <span>{option.label}</span>
                    </label>
                  ))}
                </>
              )}
            {pageName === "InCBotManageInterviews" &&
              pageName !== "MockInterviewCandidates" &&
              type !== "incScreen" && (
                <div style={{ marginTop: "8px" }}>
                  <div className="f-med title f-l">Interview Type</div>
                  {[
                    { label: "Conversational", values: ["Conversational"] },
                    {
                      label: "Non-conversational",
                      values: ["Non-conversational"],
                    },
                    { label: "Agentic Conversational", values: ["Agentic"] },
                    {
                      label: "Hiring Manager Persona",
                      values: ["Hiring Manager Persona"],
                    },
                    { label: "Coding & MCQ", values: ["Coding", "MCQ"] },
                    {
                      label: "Psychometric Assessment",
                      values: ["Psychometric Assessment"],
                    },
                    {
                      label: "Language Assessment (CEFR)",
                      values: ["Language Assessment (CEFR)"],
                    },
                  ].map(({ label, values }) => (
                    <label
                      key={label}
                      htmlFor={`interview-type-${label}`}
                      className="f-l d-flex align-items-center"
                    >
                      <input
                        id={`interview-type-${label}`}
                        type="checkbox"
                        value={values.join(",")}
                        checked={values.every((value) =>
                          filterInterviewType.includes(value),
                        )}
                        onChange={() => handleInterviewTypeChange(values)}
                      />
                      <span>{label}</span>
                    </label>
                  ))}
                </div>
              )}
            {/* [INC-1656 / INC-1698] IncScreen's own interview types. This panel is shared with
                IncBot through pageName="InCBotManageInterviews", which is why IncScreen used to
                render IncBot's options — none of which match an IncScreen record. "Call & WhatsApp"
                is its own option: it matches only candidates configured for both. */}
            {type === "incScreen" && pageName === "InCBotManageInterviews" && (
              <div style={{ marginTop: "8px" }}>
                <div className="f-med title f-l">Interview Type</div>
                {[
                  { label: "Call", values: ["call"] },
                  { label: "WhatsApp", values: ["whatsapp"] },
                  { label: "Call & WhatsApp", values: ["both"] },
                ].map(({ label, values }) => (
                  <label
                    key={label}
                    htmlFor={`interview-type-${label}`}
                    className="f-l d-flex align-items-center"
                  >
                    <input
                      id={`interview-type-${label}`}
                      type="checkbox"
                      value={values.join(",")}
                      checked={values.every((value) =>
                        filterInterviewType.includes(value),
                      )}
                      onChange={() => handleInterviewTypeChange(values)}
                    />
                    <span>{label}</span>
                  </label>
                ))}
              </div>
            )}
            {pageName !== "MockInterviewCandidates" && (
              <div className="f-med title f-l">Order By</div>
            )}
            {pageName !== "MockInterviewCandidates" &&
              Object.entries(order).map((data, index) => (
                <label
                  htmlFor={data[1]}
                  key={index}
                  className={"f-l d-flex align-items-center"}
                >
                  <input
                    type="radio"
                    value={data[1]}
                    checked={filterStates?.sort === data[1]}
                    onChange={(e) => handleFilterChange(e, "sort")}
                  />
                  <span>{data[0]}</span>
                </label>
              ))}
            {type !== "incExit" &&
              type !== "incServe" &&
              type !== "incBot" &&
              type !== "incScreen" &&
              !isIncFeedVid &&
              pageName !== "MockInterviewCandidates" && (
                <>
                  <div className="f-med title f-l">Feedback Rating</div>
                  {Object.entries(feedback).map((data, index) => (
                    <label
                      htmlFor={data[1]}
                      key={index}
                      className={"f-l d-flex align-items-center"}
                    >
                      <input
                        type="checkbox"
                        value={data[1]}
                        checked={filterStates?.feedback === data[1]}
                        onChange={(e) => handleFilterChange(e, "feedback")}
                      />
                      <span>{data[0]}</span>
                    </label>
                  ))}
                </>
              )}
            {type === "incServe" &&
              isCompleted &&
              pageName !== "MockInterviewCandidates" && (
                <>
                  <SearchSelect
                    name="approvedBy"
                    value={filterStates.approvedBy}
                    label="Approved  By"
                    onChange={(e) => handleSelectChange(e, "approvedBy")}
                    options={subusersList}
                    labelClass="mb-1 mt-2 f-med title f-l"
                    inputClass="f-12 f-sem-bol input-shadow rounded"
                    borderNone
                    placeholder={"Select a subuser"}
                  />
                  <SearchSelect
                    name="creditType"
                    value={filterStates.creditType}
                    label="Credit Type"
                    onChange={(e) => handleSelectChange(e, "creditType")}
                    options={CreditType}
                    labelClass="mb-1 mt-2 f-med title f-l"
                    inputClass="f-12 f-sem-bol input-shadow rounded"
                    borderNone
                  />
                  <SearchSelect
                    name="mode"
                    value={filterStates?.mode}
                    label="Interview Mode"
                    onChange={(e) => handleSelectChange(e, "mode")}
                    options={interviewSearchDropdownOptions.mode}
                    labelClass="mb-1 mt-2 f-med title f-l"
                    inputClass="f-l f-reg rounded input-shadow"
                    placeholder={"Select mode"}
                  />
                </>
              )}
            {pageName === "MockInterviewCandidates" && (
              <div className="filter-btn-mockinterviewcandidates">
                <div
                  className="date-container f-reg"
                  style={{ marginTop: "16px" }}
                >
                  <label htmlFor="" className={"f-l"}>
                    <span className="f-sem-bol no-wrap">From Date</span>
                    <div
                      className="filter-date-container input-shadow"
                      onClick={() => {
                        if (completedFromRef.current) {
                          completedFromRef.current.showPicker();
                        }
                      }}
                    >
                      <input
                        ref={completedFromRef}
                        type="date"
                        max={completedToRef.current?.value || ""}
                        className="filter-input"
                        onChange={handleCompletedFromChange}
                        value={fromDate || ""}
                      />
                      <div className="filter-date-placeholder f-med">
                        {fromDate
                          ? moment(fromDate).format("DD-MM-YYYY")
                          : "Select a date"}
                      </div>
                      <img
                        src={filterDateLogo}
                        alt="filter date logo"
                        className="filter-date-logo"
                      />
                    </div>
                  </label>

                  <label htmlFor="" className={"f-l"}>
                    <span className="f-sem-bol no-wrap">To Date</span>
                    <div
                      className="filter-date-container input-shadow"
                      onClick={() => {
                        if (completedToRef.current) {
                          completedToRef.current.showPicker();
                        }
                      }}
                    >
                      <input
                        ref={completedToRef}
                        type="date"
                        min={completedFromRef.current?.value || ""}
                        className="filter-input"
                        onChange={handleCompletedToChange}
                        value={toDate || ""}
                      />
                      <div className="filter-date-placeholder f-med">
                        {toDate
                          ? moment(toDate).format("DD-MM-YYYY")
                          : "Select a date"}
                      </div>
                      <img
                        src={filterDateLogo}
                        alt="filter date logo"
                        className="filter-date-logo"
                      />
                    </div>
                  </label>
                </div>

                <div className="f-med title f-l">
                  <label htmlFor="" className={"f-l"}>
                    <span className="f-sem-bol no-wrap">Status</span>
                    <div className="status-radio-group">
                      <label className={"f-l d-flex align-items-center"}>
                        <input
                          type="radio"
                          name="status"
                          value="Active"
                          className="status-radio-input"
                          checked={statusCandidate === "Active"}
                          onChange={(e) => setStatusCandidate(e.target.value)}
                        />
                        Active
                      </label>
                      <label className={"f-l d-flex align-items-center"}>
                        <input
                          type="radio"
                          name="status"
                          value="Suspended"
                          className="status-radio-input"
                          checked={statusCandidate === "Suspended"}
                          onChange={(e) => setStatusCandidate(e.target.value)}
                        />
                        Suspended
                      </label>
                      <label className={"f-l d-flex align-items-center"}>
                        <input
                          type="radio"
                          name="status"
                          value="Subscribed"
                          className="status-radio-input"
                          checked={statusCandidate === "Subscribed"}
                          onChange={(e) => setStatusCandidate(e.target.value)}
                        />
                        Subscribed
                      </label>
                    </div>
                  </label>
                </div>
              </div>
            )}

            {pageName === "MockInterviewCandidates" && (
              <>
                <div className="f-med title f-l" style={{ color: "#626262" }}>
                  Order By
                </div>
                {Object.entries(order).map(([label, value]) => (
                  <label
                    htmlFor={value}
                    key={value}
                    className="f-l d-flex align-items-center"
                  >
                    <input
                      type="radio"
                      id={value}
                      value={value}
                      checked={filterStates.sort === value}
                      onChange={handleSortChange}
                    />
                    <span>{label}</span>
                  </label>
                ))}
              </>
            )}

            <button
              className={`filter-clear-btn d-flex align-items-center justify-content-center ${
                isAnyFieldNotEmpty() ? "" : "disabled"
              }`}
              onClick={handleClearFilter}
            >
              Clear Filter
            </button>
          </div>
        )}
      </div>
    );
  },
);

export default FilterBtn;
